import { render } from "./feature-instructors.vue?vue&type=template&id=de4178de"
import script from "./feature-instructors.vue?vue&type=script&lang=js"
export * from "./feature-instructors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__